"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-right"
  }, [_c("div", {
    staticStyle: {
      height: "100%"
    }
  }, [_c("div", {
    staticClass: "tab-box"
  }, [_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.menusList, function (item, index) {
    return _c("el-tab-pane", {
      attrs: {
        label: _vm.getLable(item.name),
        name: "tag" + item.id
      },
      on: {
        key: index
      }
    }, [_vm.activeName == "tag" + item.id && item.name == "设备管理" ? _c("equipment") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "新建工单" ? _c("createOrder") : _vm._e(), _vm._v(" "), _vm.activeName == "tag" + item.id && item.name == "工单管理" ? _c("orderWork") : _vm._e()], 1);
  }), 1)], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;